export const cets_item = [
  
  {
    cets_item_text: "El Centro Estatal de la Transfusión Sanguínea es una unidad administrativa de la Secretaria de Salud por función, jerárquicamente subordinada a los Servicios de Salud de Hidalgo, que tiene como objetivo ejercer los actos de vigilancia sanitaria, dentro del ámbito de su competencia de los actos de disposición de sangre humana y sus componentes con fines terapéuticos; la captación, estudio, investigación, fraccionamiento, almacenamiento, distribución y aplicación de la misma; la capacitación de los recursos humanos en el campo de la medicina transfusional; el aseguramiento de la calidad en sus procesos, de conformidad con la Legislación Sanitaria.",
    cets_item_list: [
      "Entra en funciones el 1º. de Agosto de 1991.",
      "Se encuentra ubicado en Campo de Aviación # 1, Col Venta Prieta,",
      "Pachuca de Soto, Hidalgo (junto a AMANC),",
      "teléfono: 01 771 7133395 y 01 771 107 0895,",
      "correo electrónico: cets@ssh.gob.mx",
    ],
  },
]